export default __webpack_public_path__ + "static/media/loader.c0a3ccc0.gif";